import { t } from '../i18n';
import { state } from '../store';

const REWARD_LABELS: Record<number, { en: string; ru: string }> = {
  1:  { en: '🏅 +200 coins',         ru: '🏅 +200 монет' },
  3:  { en: '3 days Premium 👑',      ru: '3 дня Premium 👑' },
  10: { en: '14 days Premium 👑',     ru: '14 дней Premium 👑' },
  25: { en: 'Lifetime Premium 🌟',   ru: 'Вечный Premium 🌟' },
};

export function getNextMilestoneText(
  totalInvited: number,
  milestones: Array<{ count: number; claimed: boolean }>,
): string {
  const next = milestones.find(m => !m.claimed);
  if (!next) return t('invite_milestone_all_done');

  const needed = Math.max(0, next.count - totalInvited);
  const lang = state.user?.lang === 'ru' ? 'ru' : 'en';
  const reward = REWARD_LABELS[next.count]?.[lang] || '🎁';

  if (needed <= 0) {
    return lang === 'ru' ? `${reward} — готово к получению!` : `${reward} — ready to collect!`;
  }
  if (lang === 'ru') {
    const friendWord = needed === 1 ? 'друга' : 'друзей';
    return `🎁 Ещё ${needed} ${friendWord} → ${reward}`;
  }
  return `🎁 ${needed} more friend${needed === 1 ? '' : 's'} → ${reward}`;
}
